module.exports = new __parcel__URL__("corporealprotection.3c4481cb.png").toString();